import { Environment } from "./env";

export const ProdEnvironment: Environment = {
  base_url: "https://aaneelconnect-api.aaneelconnect.com",
  temp_base_url: "https://aaneelconnect-api-sandbox.aaneelconnect.com",
};
